// Classifie l'echec de GET /api/me pour AccessGate.
//
// Socle UNIQUE (D3 MASTER-ACCESSGATE-INDISPONIBLE) : les quatre apps ne recopient
// plus le fail-soft. Un 403 *_USER_NOT_PROVISIONED reste un refus. Tout le reste
// (500, reseau, autre 403, 401) est « acces non verifiable » — l'ecran informe,
// il n'ouvre pas l'app en silence et ne pretend pas un non-provisionnement.
//
// Pas de `instanceof` sur les classes @gs/api-client : dans un worktree dont
// node_modules/@gs/* jonctionne le principal, l'erreur construite et le
// classifieur n'ont pas la meme identite de classe. On lit `originalBody`.

export type MeAccessErrorKind = 'notProvisioned' | 'unverifiable';

/**
 * Lit le code metier que createErrorHandler pose dans le body HTTP.
 * Accepte le format legacy `{ code }` et le format unifie `{ error: { code } }`.
 */
export function readApiErrorCode(body: unknown): string | undefined {
  if (!body || typeof body !== 'object') return undefined;
  const o = body as { code?: unknown; error?: { code?: unknown } };
  if (typeof o.code === 'string') return o.code;
  if (o.error && typeof o.error === 'object' && typeof o.error.code === 'string') {
    return o.error.code;
  }
  return undefined;
}

function originalBodyOf(error: unknown): unknown {
  if (!error || typeof error !== 'object') return undefined;
  if (!('originalBody' in error)) return undefined;
  return (error as { originalBody?: unknown }).originalBody;
}

/**
 * Verdict d'un GET /api/me en erreur. N'est appele QUE lorsque `isError` est vrai.
 * Ne dit rien d'un succes (entitlement / role) — ca reste propre a chaque app.
 */
export function classifyMeAccessError(
  error: unknown,
  provisionedCode: string,
): MeAccessErrorKind {
  if (readApiErrorCode(originalBodyOf(error)) === provisionedCode) {
    return 'notProvisioned';
  }
  return 'unverifiable';
}
